import clsx from 'clsx'
import React from 'react'

import {useDrawerStyles} from './styles'

type Props = {
  fullHeight?: boolean
  className?: string
}

const DrawerSection: React.FC<React.PropsWithChildren<Props>> = ({className, children, fullHeight}) => {
  const classes = useDrawerStyles()
  return <div className={clsx(classes.section, fullHeight && classes.fullHeightContent, className)}>{children}</div>
}

export default DrawerSection
